import rootReducer from "./reducers";
import { history, createLoggerMiddleware, createRouterMiddleware } from "./buildEnv";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
    reducer: rootReducer(history),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false
    }).prepend(createRouterMiddleware()).concat(createLoggerMiddleware()),
    devTools: process.env.NODE_ENV !== "production",
});

export default store;

export type AppStore = typeof store

export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

export { useAppDispatch, useAppSelector } from './hooks';